import { Box } from "@mui/material"
import CircularIndeterminate from "components/blocks/progressBar/progressBar"
import { AppContext } from "contexts/AppContext"
import { useContext, useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"

const ShopRedirect = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const { accessibleShops } = useContext(AppContext)

    useEffect(() => {
        if(accessibleShops.length) {
            const ShopID = accessibleShops[0].ShopID
            const path = `/shop/${ShopID}${location.search}`
            navigate(path)
        }
    }, [accessibleShops])

    return (
        <Box marginTop={4} display={'flex'} flex={1} justifyContent={'center'} >
            <CircularIndeterminate />
        </Box>
    )
}

export default ShopRedirect